export default "__VITE_ASSET__ChfFGMdE__"